import Vue from "vue";
import App from "./App.vue";
import { Toast, Tab, Tabs, Empty, ActionSheet, Picker, Popup } from "vant";
import api from "./api";
import CommonRow from "./components/common/commonRow.vue";
import CommonEmpty from "./components/common/commonEmpty.vue";
import VueI18n from "vue-i18n";

Vue.config.productionTip = false;
Vue.component("CommonRow", CommonRow); // 注册全局组件 - 标题行
Vue.component("CommonEmpty", CommonEmpty); // 注册全局组件 - 空状态

// 国际化插件引入
Vue.use(VueI18n);
// vant组件引入
Vue.use(Toast); // 轻提示组件
Vue.use(Tab); // 标签页组件
Vue.use(Tabs); // 标签页组件
Vue.use(Empty); // 空状态组件
Vue.use(ActionSheet); // 动作面板组件
Vue.use(Picker); // 选择器组件
Vue.use(Popup); // 弹窗组件
// 挂载到 Vue 原型
Vue.prototype.$api = api;
Vue.prototype.$toast = Toast;

const i18n = new VueI18n({
  locale: "zh-CN", // 默认语言为英文
  messages: {
    "zh-CN": require("./locales/zh-CN.js").default,
    en: require("./locales/en.js").default,
  },
});
new Vue({
  i18n,
  render: (h) => h(App),
}).$mount("#app");
